import React, { useState } from "react";
import Footer from "../../../../Kryzen Alpha App/Components/Footer/footer";
import StepRoutes from "../../../../Kryzen Alpha App/Routes/steps_routes";
import { FcVoicePresentation } from "react-icons/fc";
import SimpleButton from "../../../Components/layouts/simple_button";
import { Formik, Form, Field } from "formik";
import { Toast } from "../../../../Kryzen Alpha App/CustomComponent/toast";
import performRequest from "../../../../Kryzen Alpha App/api/request";
import LoadingPage from "../../../../Kryzen Alpha App/Components/layouts/loading";
import { useParams } from "react-router";
import { useEffect } from "react";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import CustomInput from "../../../CustomComponent/custom_input";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import { nhmApplicants } from "../../../SchemaInfo/info";
import { nhmApplicantsSchema } from "../../../Schemas/NHM Applicants/nhm_applicants_schema";
import CustomRadioButton from "../../../CustomComponent/custom_radio";
import CustomSelect from "../../../CustomComponent/custom_select";
import { useLocation, useNavigate } from "react-router";

const ViewEligibleFarmer = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  let { maskNhmNumber } = useParams();
  const navigate = useNavigate();
  const [openModel, setOpenModel] = useState(false);

  useEffect(() => {
    setLoading(true);
    performRequest(
      "GET",
      `/nhm-applicants/getNHMDataByMaskNumber/${maskNhmNumber}`
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting Expense!");
        }
        setLoading(false);
      })

      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [maskNhmNumber]);

  const handelSubmit = (values, actions) => {
    values = { ...values, seenStatus: "reachedToAlpha" };
    let formData = new FormData();
    for (let key in values) {
      if (values[key]) {
        formData.append(key, values[key]);
      }
    }
    const headers = { "Content-Type": "multipart/form-data" };

    setLoading(true);
    performRequest(
      "PATCH",
      `/nhm-applicants/updateNHMApplicants/${maskNhmNumber}`,
      formData,
      headers
    )
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Application Sumbited successfully!");
          //   navigate(`/`);
          setOpenModel(true);
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error");
        // console.error("Error", err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          {/* HEADER */}
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                {/* <h1 className="page-title mb-1 justify-content-center fs-1 p-2">
                  👨‍🌾 शेडनेट हाऊस योजना पात्रता तपासणी
                </h1> */}
                <h1 className="page-title mb-1 justify-content-center fs-1 p-2">
                  👨‍🌾 {data?.Structure} Schema Eligibility
                </h1>
                {/* <h4 className="text-muted">
                  <StepRoutes />
                </h4> */}
              </div>
              <hr></hr>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-3">
              {" "}
              {/* FORM FOR ELIGIBILITY CHECK */}
              <div className="card my-4">
                <div className="card-header bg-success-lt">
                  <h2 className="page-title"> आवश्यक कागदपत्रे </h2>
                </div>
                <div className="card-body">
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item">
                      अर्जदाराचा ७/१२ व ८ अ उतारा
                    </li>
                    <li className="list-group-item">
                      अनुसूचित जाती किंवा जमाती प्रवर्गातील असल्यास त्याबाबतचा
                      पुरावा
                    </li>
                    <li className="list-group-item">
                      अर्जदार दिव्यांग असल्यास त्याचे प्रमाणपत्र
                    </li>
                    <li className="list-group-item">
                      शेडनेट हाऊस संदर्भातील प्रशिक्षण प्रमाणपत्र
                    </li>
                  </ul>
                </div>
              </div>
              <div className="card my-4">
                <div className="card-header bg-success-lt">
                  <h2 className="page-title"> शेती अनुदानाची माहिती </h2>
                </div>
                <div className="card-body">
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item">
                      अनुदान टक्केवारी :{" "}
                      {data?.subsidyPercent?.toString() + " %" || "उपलब्ध नाही"}
                    </li>
                    <li className="list-group-item">
                      कमाल अनुदान (रु.) :{" "}
                      {data?.maxSubsidyRs?.toString() || "उपलब्ध नाही"}
                    </li>
                    <li className="list-group-item">
                      एकूण अर्ज :{" "}
                      {data?.applications?.toString() || "उपलब्ध नाही"}
                    </li>
                    <li className="list-group-item">
                      पूर्व मंजुरी संख्या :{" "}
                      {data?.preSanction?.toString() || "उपलब्ध नाही"}
                    </li>
                    <li className="list-group-item">
                      वितरण संख्या :{" "}
                      {data?.disbursementCount?.toString() || "उपलब्ध नाही"}
                    </li>
                  </ul>
                </div>
              </div>
              <div className="card my-4">
                <div className="card-header bg-success-lt ">
                  <h2 className="page-title"> पात्रता निकष </h2>
                </div>
                <div className="card-body">
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item">
                      ग्राम कृषि संजीवनी समितीने मान्यता दिलेले अत्यल्प व अल्प
                      भूधारक शेतकरी, २ ते ५ हेक्टर जमीनधारणा असलेले शेतकरी तसेच
                      अनु.जाती/जमाती, महिला, दिव्यांग शेतकऱ्यांना प्राधान्य.
                    </li>
                    <li className="list-group-item">
                      पूर्वी इतर योजनेचा लाभ घेतल्यास एकत्रित मर्यादा ४० गुंठे.
                    </li>
                    <li className="list-group-item">
                      स्वतःची जमीन, पाणी व वीजपुरवठा आवश्यक.
                    </li>
                    <li className="list-group-item">
                      सेवा पुरवठादाराकडून तांत्रिक निकषानुसार उभारणी केल्याचे
                      प्रमाणपत्र आवश्यक.
                    </li>
                    <li className="list-group-item">
                      ५०० चौ.मी. ते ४००० चौ.मी. पर्यंत क्षेत्र मर्यादा.
                    </li>
                    <li className="list-group-item">
                      शेडनेट हाऊस प्रशिक्षण अनुदान अदायगीपूर्वी घेणे आवश्यक.
                    </li>
                    <li className="list-group-item">
                      तांत्रिक निकष व आराखडा मार्गदर्शक सूचनांनुसार ग्राह्य
                      धरण्यात येईल.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-9">
              {" "}
              {/* FORM FOR ELIGIBILITY CHECK */}
              <div className="card my-4">
                <div className="">
                  <div className="card-header bg-primary-lt text-white">
                    <h2 className="page-title">🔍 शेतकरी तपशील </h2>
                  </div>

                  <div className="card-body">
                    {data && (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">नाव :</label>
                        <div className="w-100 col">
                          {data?.Name?.toUpperCase() || "उपलब्ध नाही"}
                        </div>
                      </div>
                    )}

                    {data && (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          संपर्क क्रमांक :
                        </label>
                        <div className="w-100 col">
                          {data?.Mobile || "उपलब्ध नाही"}
                        </div>
                      </div>
                    )}

                    {data && (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">गाव :</label>
                        <div className="w-100 col">
                          {data?.Village?.toUpperCase() || "उपलब्ध नाही"}
                        </div>
                      </div>
                    )}

                    {data && (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          तालुका :
                        </label>
                        <div className="w-100 col">
                          {data?.Taluka?.toUpperCase() || "उपलब्ध नाही"}
                        </div>
                      </div>
                    )}

                    {data && (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          जिल्हा :
                        </label>
                        <div className="w-100 col">
                          {data?.District?.toUpperCase() || "उपलब्ध नाही"}
                        </div>
                      </div>
                    )}

                    {data && (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          रचना प्रकार :
                        </label>
                        <div className="w-100 col">
                          {data?.Structure?.toUpperCase() || "उपलब्ध नाही"}
                        </div>
                      </div>
                    )}

                    {data && (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          सिस्टम :
                        </label>
                        <div className="w-100 col">
                          {data?.System?.toUpperCase() || "उपलब्ध नाही"}
                        </div>
                      </div>
                    )}

                    {data && (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          ट्युब्युलर स्ट्रक्चर :
                        </label>
                        <div className="w-100 col">
                          {data?.TubularStructure?.toUpperCase() ||
                            "उपलब्ध नाही"}
                        </div>
                      </div>
                    )}

                    {data?.size && (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">आकार :</label>
                        <div className="w-100 col">
                          {data?.size?.toString() || "उपलब्ध नाही"}
                        </div>
                      </div>
                    )}

                    {data?.areaSqM && (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          क्षेत्रफळ (चौ.मी.) :
                        </label>
                        <div className="w-100 col">
                          {data?.areaSqM?.toString() || "उपलब्ध नाही"}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div>
                <div className="card my-5">
                  <div className="card-header bg-primary-lt p-3">
                    <h2 className="page-title ">📋 अनुदानासाठी अर्ज करा</h2>
                  </div>
                  <Formik
                    initialValues={nhmApplicants}
                    validationSchema={nhmApplicantsSchema}
                    onSubmit={handelSubmit}
                  >
                    {(props) => (
                      <Form>
                        <div className="card-body mt-2">
                          <div className="mb-4 row">
                            <label className="w-25 form-label col-3">
                              संभाव्य प्रारंभ दिनांक :
                            </label>
                            <div className="w-100 col">
                              <CustomSelect type="text" name="tenDate">
                                <option value="">निवडा</option>
                                <option value="Next 15 days">
                                  पुढील १५ दिवस
                                </option>
                                <option value="Next 1 -2 month">
                                  पुढील १ - २ महिने
                                </option>
                                <option value="Next 3-4 months">
                                  पुढील ३ - ४ महिने
                                </option>
                              </CustomSelect>

                              {props.touched.tenDate &&
                                props.errors.tenDate && (
                                  <p className="text-danger">
                                    {props.errors.tenDate}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-4 row">
                            <label className="w-25 form-label col-3">
                              बँक कर्जासाठी शोधत आहात का? :
                            </label>
                            <div className="col-9">
                              <div className="d-flex gap-3">
                                <CustomRadioButton
                                  type="radio"
                                  name="bankLoan"
                                  value="yes"
                                />
                                <label>होय</label>
                                <CustomRadioButton
                                  type="radio"
                                  name="bankLoan"
                                  value="no"
                                />
                                <label>नाही</label>
                              </div>
                              {props.touched.bankLoan &&
                                props.errors.bankLoan && (
                                  <p className="text-danger">
                                    {props.errors.bankLoan}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-4 row">
                            <label className="w-25 form-label col-3">
                              पर्यायी संपर्क क्रमांक :
                            </label>
                            <div className="w-100 col">
                              <CustomInput
                                name="alterContactNo"
                                type="text"
                                placeholder="उदाहरण:- 9900886677"
                              />
                              {props.touched.alterContactNo &&
                                props.errors.alterContactNo && (
                                  <p className="text-danger">
                                    {props.errors.alterContactNo}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-4 row">
                            <label className="w-25 form-label  col-3">
                              अर्जदाराचा ७/१२ :
                            </label>
                            <div className="w-100 col">
                              <CustomInput
                                name="satbaraDoc"
                                type="file"
                                onChange={(e) =>
                                  props.setFieldValue(
                                    "satbaraDoc",
                                    e.target.files[0]
                                  )
                                }
                              />
                              {props.touched.satbaraDoc &&
                                props.errors.satbaraDoc && (
                                  <p className="text-danger">
                                    {props.errors.satbaraDoc}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-4 row">
                            <label className="w-25 form-label col-3">
                              अर्जदाराचा ८ अ उतारा :
                            </label>
                            <div className="w-100 col">
                              <CustomInput
                                name="utaraDoc"
                                type="file"
                                onChange={(e) =>
                                  props.setFieldValue(
                                    "utaraDoc",
                                    e.target.files[0]
                                  )
                                }
                              />
                              {props.touched.utaraDoc &&
                                props.errors.utaraDoc && (
                                  <p className="text-danger">
                                    {props.errors.utaraDoc}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-4 row">
                            <label className="w-25 form-label col-3">
                              अनुसूचित जाती किंवा जमाती प्रवर्गातील असल्यास
                              त्याबाबतचा पुरावा :
                            </label>
                            <div className="w-100 col">
                              <CustomInput
                                name="castDoc"
                                type="file"
                                onChange={(e) =>
                                  props.setFieldValue(
                                    "castDoc",
                                    e.target.files[0]
                                  )
                                }
                              />
                              {props.touched.castDoc &&
                                props.errors.castDoc && (
                                  <p className="text-danger">
                                    {props.errors.castDoc}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-4 row">
                            <label className="w-25 form-label col-3">
                              अर्जदार दिव्यांग असल्यास त्याचे प्रमाणपत्र :
                            </label>
                            <div className="w-100 col">
                              <CustomInput
                                name="certiDoc"
                                type="file"
                                onChange={(e) =>
                                  props.setFieldValue(
                                    "certiDoc",
                                    e.target.files[0]
                                  )
                                }
                              />
                              {props.touched.certiDoc &&
                                props.errors.certiDoc && (
                                  <p className="text-danger">
                                    {props.errors.certiDoc}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-4 row">
                            <label className="w-25 form-label col-3">
                              शेडनेट हाऊस संदर्भातील प्रशिक्षण प्रमाणपत्र :
                            </label>
                            <div className="w-100 col">
                              <CustomInput
                                name="studyDoc"
                                type="file"
                                onChange={(e) =>
                                  props.setFieldValue(
                                    "studyDoc",
                                    e.target.files[0]
                                  )
                                }
                              />
                              {props.touched.studyDoc &&
                                props.errors.studyDoc && (
                                  <p className="text-danger">
                                    {props.errors.studyDoc}
                                  </p>
                                )}
                            </div>
                          </div>
                        </div>

                        <div className="card-footer">
                          <div className="btn-list justify-content-end">
                            <FormSubmitButton buttonText="सादर करा" />

                            <SimpleButton
                              buttonText="रद्द करा"
                              type="secondary"
                            />
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>

          {/* Farmer Info Display */}

          {/* DOCUMENTS & CRITERIA */}
          {/* <div className="card my-4">
            <div className="card-header bg-success text-white">
              <h2 className="page-title"> आवश्यक कागदपत्रे </h2>
            </div>
            <div className="card-body">
              <ul className="list-group list-group-flush">
                <li className="list-group-item">अर्जदाराचा ७/१२ व ८ अ उतारा</li>
                <li className="list-group-item">
                  अनुसूचित जाती किंवा जमाती प्रवर्गातील असल्यास त्याबाबतचा
                  पुरावा
                </li>
                <li className="list-group-item">
                  अर्जदार दिव्यांग असल्यास त्याचे प्रमाणपत्र
                </li>
                <li className="list-group-item">
                  शेडनेट हाऊस संदर्भातील प्रशिक्षण प्रमाणपत्र
                </li>
              </ul>
            </div>
          </div> */}
          {openModel && (
            <div
              className={`modal modal-blur fade show d-block`}
              id="modal-thankyou"
              tabIndex="-1"
              role="dialog"
              aria-modal="true"
              style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
            >
              <div
                className="modal-dialog modal-md modal-dialog-centered"
                role="document"
              >
                <div className="modal-content">
                  <div className="modal-header bg-success text-white">
                    <h5 className="modal-title">🎉 धन्यवाद!</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setOpenModel(false)}
                    ></button>
                  </div>
                  <div className="modal-body text-center">
                    <h4 className="text-success mb-3">
                      आपला अनुदान अर्ज यशस्वीरित्या सादर झाला आहे!
                    </h4>
                    <p className="text-muted">
                      आपला अर्ज तपासणीसाठी संबंधित विभागाकडे पाठविण्यात आला आहे.
                      कृपया पुढील सूचनांसाठी प्रतीक्षा करा.
                    </p>
                  </div>
                  <div className="modal-footer justify-content-center">
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => setOpenModel(false)}
                    >
                      ठीक आहे
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default ViewEligibleFarmer;
